import React from 'react';
import PropTypes from 'prop-types';

import { find, map } from 'lodash';

const ShopSelect = ({ items, onSelectItem, activeItemId }) => {
  const onSelect = (e) => {
    const itemId = e.target.value;
    const item = find(items, { id: itemId });

    onSelectItem(item);
  };

  const options = map(items, item => (
    <option value={item.id} key={item.id}>
      {item.type === 'brand' ? item.brandName : item.name}
    </option>
  ));

  return (
    <select className="c-shops-navigation__mobile" onChange={onSelect} value={activeItemId}>
      {options}
    </select>
  );
};

ShopSelect.propTypes = {
  items: PropTypes.object.isRequired,
  onSelectItem: PropTypes.func.isRequired,
  activeItemId: PropTypes.string.isRequired,
};

export default ShopSelect;
